import { Sparkles, History, X } from "lucide-react";

const PROVIDERS = [
  { id: "anthropic", label: "Claude Sonnet 4.5" },
  { id: "openai", label: "GPT-5.2" },
  { id: "gemini", label: "Gemini 3 Flash" },
];

/**
 * Header row + provider picker for the AI assistant dock.
 */
export default function AssistantHeader({
  provider, onProviderChange, showHistory, onToggleHistory, onClose,
}) {
  return (
    <>
      <div className="p-4 flex items-center gap-3 border-b border-slate-200">
        <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#7B2CBF] flex items-center justify-center animate-pulse-glow">
          <Sparkles size={16} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-semibold">NEXUS Assistant</div>
          <div className="text-xs text-[#64748B]">Streaming · Persistent · Multi-model</div>
        </div>
        <button
          data-testid="toggle-history"
          onClick={onToggleHistory}
          className={`w-8 h-8 rounded-full flex items-center justify-center ${
            showHistory ? "glass-active text-[#00E5FF]" : "hover:bg-slate-100"
          }`}
          title="History"
        >
          <History size={14} />
        </button>
        <button
          data-testid="close-ai-assistant"
          onClick={onClose}
          className="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center"
          aria-label="Close"
        >
          <X size={16} />
        </button>
      </div>
      <div className="px-4 pt-3 flex items-center gap-2 flex-wrap">
        {PROVIDERS.map((p) => (
          <button
            key={p.id}
            data-testid={`provider-${p.id}`}
            onClick={() => onProviderChange(p.id)}
            className={`text-xs px-3 py-1.5 rounded-full transition-all ${
              provider === p.id
                ? "glass-active text-[#00E5FF]"
                : "glass text-[#64748B] hover:text-[#0F172A]"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
    </>
  );
}
